// Add active to first button on start top
//jQuery( '.packages-tab .tablinks:nth-child(n/3)' ).addClass( 'active' );
jQuery( '.packages-tab').find('.tablinks:first' ).addClass( 'active' );